import { Dir } from '@angular/cdk/bidi';
import { AfterViewInit, ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIcon } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { ClickStopPropagationDirective } from '@src/suite/common/directives/stop-propagation';

import { BaseMainCtaComponent } from '../base-main-cta.component';

@Component({
    selector: 'st-cast-main-cta',
    imports: [ClickStopPropagationDirective, Dir, MatButtonToggleModule, MatIcon, MatListModule, MatMenuModule],
    templateUrl: './cast-main-cta.component.html',
    styleUrl: './cast-main-cta.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-cast-main-cta',
    },
})
export class CastMainCtaComponent extends BaseMainCtaComponent implements AfterViewInit {}
